<template>
    <form>
        <div class="form-row">
            <div class="col-5">
                <label for="subject">Vorgang</label>
                <input
                    v-model="t_text"
                    type="text"
                    class="form-control"
                    id="subject"
                    placeholder="Vorgang"
                    title="Kurzer Text, der die Buchung beschreibt"
                    @keydown.enter.prevent
                >
            </div>
            <div class="col-3">
                <label for="category">Buchungskategorie</label>
                <div class="custom-dropdown" @click="toggleDropdown" ref="dropdown">
                    <div class="dropdown-selected" :class="{ 'open': isDropdownOpen }">
                        <div class="selected-category" v-if="t_category.id">
                            <span
                                class="color-indicator"
                                :style="{ backgroundColor: t_category.background_color || '#007bff' }"
                            ></span>
                            {{ t_category.name }}
                        </div>
                        <div v-else class="placeholder">Bitte wählen...</div>
                        <span class="dropdown-arrow">▼</span>
                    </div>
                    <div class="dropdown-options" v-show="isDropdownOpen">
                        <div
                            class="dropdown-option placeholder-option"
                            @click.stop="selectCategory({ id: null, name: '' })"
                        >
                            Bitte wählen...
                        </div>
                        <div
                            v-for="category in categories"
                            :key="category.id"
                            class="dropdown-option"
                            @click.stop="selectCategory(category)"
                        >
                            <span
                                class="color-indicator"
                                :style="{ backgroundColor: category.background_color || '#ffffff' }"
                            ></span>
                            {{ category.name }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="col">
                <label for="receipt-id">Kassenanordnungsnummer</label>
                <input
                    v-model="t_receiptInfo"
                    type="text"
                    class="form-control"
                    id="receipt-id"
                    placeholder="Kassenanordnungsnummer"
                    autocomplete="off"
                    title="Identifikationsnummer der entsprechenden Kassenanordnung"
                    @keydown.enter.prevent
                >
            </div>
        </div>
        <div class="form-row">
            <div class="col">
                <label for="entryDate" title="Wann ist die Buchung erfolgt?">Datum</label>
                <datepicker
                    format="yyyy-MM-dd"
                    v-model="t_date"
                    input-class="form-control"
                    :language="de"
                    :monday-first=true
                    id="entryDate"
                    :disabled-dates="{from: new Date()}"
                    @keydown.enter.prevent
                >
                </datepicker>
            </div>
            <div class="col">
                <label for="amount">Betrag</label>
                <div class="input-group">
                    <input
                        v-model="t_amount"
                        title="Betrag in EUR, nur postive Werte eintragen"
                        type="number"
                        lang="de"
                        step="0.01"
                        min="0"
                        class="form-control"
                        id="amount"
                        placeholder="0,00"
                        @keydown.enter.prevent
                    />
                    <div class="input-group-append">
                        <span class="input-group-text">€</span>
                    </div>
                </div>
            </div>
            <div class="col">
                <label for="files">Belegupload</label>
                <input
                    class="form-control-file"
                    type="file" id="files" ref="files" multiple
                    accept=".pdf, .jpg, .jpeg, .png"
                    v-on:change="handleFileUpload()"
                />
            </div>
        </div>
            <div class="form-row d-flex justify-content-end">
            <div class="p-0">
                <a v-on:click="perform('INPUT', $event)" v-on:submit.prevent="onSubmit" class="btn btn-success" href="#" role="button">
                    Einnahme buchen
                </a>
            </div>
        </div>
        <div class="form-row d-flex justify-content-end">
            <div class="p-0">
                <button v-on:click="perform('OUTPUT', $event)" v-on:submit.prevent="onSubmit" class="btn btn-danger">
                    Ausgabe buchen
                </button>
            </div>
        </div>
        
    </form>
</template>

<script>
import axios from 'axios';
import Datepicker from 'vuejs-datepicker';
import {en, de} from 'vuejs-datepicker/dist/locale'

export default {
    name: 'BookEntry',
    components: {
        Datepicker
    },
    data() {
        return {
            account: 'Default',
            error_msg: 'No Error',
            t_text: '',
            t_receiptInfo: '',
            t_counterAcc: '',
            t_amount: '',
            t_category: {
                id: null,
                name: ''
            },
            t_date: '',
            t_files: null,
            en: en,
            de: de,
            isDropdownOpen: false,
        }
    },
    mounted() {
        // Close dropdown when clicking outside
        document.addEventListener('click', this.handleOutsideClick);
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleOutsideClick);
    },
    methods: {
        handleFileUpload() {
            // check if one of files is PDF and if the number of files is greater than 1, show error
            if (this.$refs.files.files.length > 1) {
                for (let i = 0; i < this.$refs.files.files.length; i++) {
                    if (this.$refs.files.files[i].type === "application/pdf") {
                        this.$refs.files.value = null
                        this.t_files = null
                        let msg = {
                            message: "Merfachauswahl ist nur für Bilder erlaubt",
                            type: "ERROR"
                        }
                        this.$store.commit('add_message', msg)
                        return
                    }
                }
            }
            if (this.$refs.files.files.length > 10) {
                this.$refs.files.value = null
                this.t_files = null
                let msg = {
                    message: "Maximal 10 Dateien erlaubt",
                    type: "ERROR"
                }
                this.$store.commit('add_message', msg)
                return
            }
            this.t_files = this.$refs.files.files;
        },
        perform(actionType, event) {
            event.preventDefault();
            var msg = null
            if (this.t_text == "") {
                msg = {
                    message: "Kein Vorgang eingetragen",
                    type: "ERROR"
                }
                this.$store.commit('add_message', msg)
            }
            if (this.t_receiptInfo == "") {
                msg = {
                    message: "Keine Kassenanordnungsnummer eingetragen",
                    type: "ERROR"
                }
                this.$store.commit('add_message', msg)
            }
            if (this.t_amount == "") {
                msg = {
                    message: "Kein Betrag eingetragen",
                    type: "ERROR"
                }
                this.$store.commit('add_message', msg)
            }
            if (this.t_files === null) {
                msg = {
                    message: "Kein Beleg zum Upload ausgewählt",
                    type: "ERROR"
                }
                this.$store.commit('add_message', msg)
            }
            if (msg !== null) {
                return
            }
            let actionTypeText = "Ausgabe";
            if (actionType === "INPUT") {
                actionTypeText = "Einnahme";
            }
            if (!confirm(actionTypeText + ' bestätigen?')) {
                return;
            }
            const data = new FormData();
            data.append('accName', this.accountName)
            data.append('receiptInfo', this.t_receiptInfo)
            data.append('text', this.t_text)
            data.append('amount', this.t_amount)
            console.log("Category: " + this.t_category.name)
            console.log("Category id: " + this.t_category.id)
            if (this.t_category.id) {
                data.append('category_id', this.t_category.id)
            }
            let dateStr = "";
            if (this.t_date) {
                dateStr = this.$filters.formatDate(this.t_date.toISOString());
            }
            data.append('date', dateStr)
            data.append('actionType', actionType)
            for (let i = 0; i < this.t_files.length; i++) {
                let file = this.t_files[i];
                data.append('file' + i, file);
            }
            let credentials = JSON.parse(localStorage.getItem('credentials'))
            axios({
                url: process.env.VUE_APP_ROOT_API
                    + '/account/'
                    + this.accountName
                    + '/entries',
                data: data,
                auth: credentials,
                method: 'post'
            })
                .catch(e => {
                    // eslint-disable-next-line
                    console.log(e);
                })
                .then(resp => {
                    msg = resp.data
                    if (!(msg.type === "NONE")) {
                        // eslint-disable-next-line
                        console.log("Pushing error")
                        this.$store.commit('add_message', msg)
                    }
                    this.$store.dispatch('loadCurrentAccount');
                    this.$store.dispatch('loadAccounts');
                });
            this.t_text = ''
            this.t_receiptInfo = ''
            this.t_counterAcc = ''
            this.t_amount = ''
            this.t_date = ''
            this.t_files = null
            this.$refs.files.value = null

        },
        toggleDropdown() {
            this.isDropdownOpen = !this.isDropdownOpen;
        },
        selectCategory(category) {
            this.t_category = category;
            this.toggleDropdown();
        },
        handleOutsideClick(event) {
            if (this.$refs.dropdown && !this.$refs.dropdown.contains(event.target)) {
                this.isDropdownOpen = false;
            }
        }
    },
    computed: {
        accountName () {
            return this.$store.state.current_acc
        },
        categories () {
            return this.$store.state.transaction_categories
        }
    }
}
</script>

<style scoped>
.custom-dropdown {
    position: relative;
}

.dropdown-selected {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border: 1px solid #ced4da;
    border-radius: 0.25rem;
    background-color: #fff;
    transition: border-color 0.2s;
    height:calc(2.25rem + 2px);
}

.dropdown-selected.open {
    border-color: #80bdff;
    box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.selected-category {
    display: flex;
    align-items: center;
}

.color-indicator {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-right: 8px;
    border: 1px solid #dee2e6;
}

.dropdown-arrow {
    margin-left: 8px;
    transition: transform 0.2s;
}

.dropdown-selected.open .dropdown-arrow {
    transform: rotate(180deg);
}

.dropdown-options {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 1000;
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid #ced4da;
    border-top: none;
    background-color: #fff;
    border-radius: 0 0 0.25rem 0.25rem;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.dropdown-option {
    padding: 10px;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
}

.dropdown-option:hover {
    background-color: #f8f9fa !important;
}

.placeholder-option {
    color: #6c757d;
    background-color: #fff !important;
}

.placeholder-option:hover {
    background-color: #f8f9fa !important;
}
</style>
